// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    projectId: 'sublime-expeditions-operacion',
    appId: '1:967853252931:web:27cd52d59489a1f03f0ff6',
    storageBucket: 'sublime-expeditions-operacion.appspot.com',
    locationId: 'us-central',
    apiKey: 'AIzaSyBWzuwLodez0SFnQU4iQf3BMR7tpg6K03c',
    authDomain: 'sublime-expeditions-operacion.firebaseapp.com',
    messagingSenderId: '967853252931',
    measurementId: 'G-HGFHT7ZTEX',
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
